<template>
  <div class="w-100">
    <h1>Product top sell report</h1>

    <div class="row mt-4">
<!--      <div class="col-lg-3">-->
<!--        <label for="type">Filter by :</label>-->
<!--        <select v-model="inputFilters.saleBy" id="type" class="form-control">-->
<!--          <option selected value="supplier">supplier</option>-->
<!--          <option value="agent">agent</option>-->
<!--        </select>-->
<!--      </div>-->
      <div class="col-lg-3">
        <label for="date-datepicker">Filter by date:</label>
        <date-picker
            v-model="inputFilters.date"
            id="date-datepicker"
            locale="en"
            format="YYYY-MM-DD"
            range
            clearable
            color="#f42f4b"
        />
      </div>
      <div class="col-lg-2">
        <label class="d-block" style="visibility: hidden">Filter</label>
        <button class="btn btn-primary" @click="filter">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      By default without date filter, statistic generated with start of month until now
      <table class="table mt-2">
        <thead class="thead-light">
        <tr>
          <th scope="col">Product</th>
          <th scope="col" @click="sortData('total_sales')">
            <i style="font-size: 18px" :class="`${sortBy === 'total_sales' ? 'fa fa-angle-down' : 'fa fa-angle-up'}`"></i>
            Sales count
          </th>
          <th scope="col" @click="sortData('online_sales')">
            <i style="font-size: 18px" :class="`${sortBy === 'online_sales' ? 'fa fa-angle-down' : 'fa fa-angle-up'}`"></i>
            Online Sales count

          </th>
          <th scope="col" @click="sortData('offline_sales')">
            <i style="font-size: 18px" :class="`${sortBy === 'offline_sales' ? 'fa fa-angle-down' : 'fa fa-angle-up'}`"></i>
            Offline Sales count</th>
          <th scope="col" @click="sortData('corporate_sales')">
            <i style="font-size: 18px" :class="`${sortBy === 'corporate_sales' ? 'fa fa-angle-down' : 'fa fa-angle-up'}`"></i>
            Corporate Sales count</th>
          <th scope="col" @click="sortData('seller_sales')">
            <i style="font-size: 18px" :class="`${sortBy === 'seller_sales' ? 'fa fa-angle-down' : 'fa fa-angle-up'}`"></i>
            Seller Sales count</th>
        </tr>
        </thead>
        <tbody>
        <!--          <router-link tag="tr" :to="{ name: 'cart.show', params: {id: cart.id}}" v-for="cart in items" v-bind:key="cart.id" style="cursor:pointer;">-->
        <tr v-if="sales.length === 0">
          <td style="color: darkred" colspan="2">Data not available, change your date filter</td>
        </tr>
        <tr v-else v-for="sale in sales">
          <td>{{ sale.product_title }}</td>
          <td>{{ sale.total_sales }}</td>
          <td>{{ sale.online_sales }}</td>
          <td>{{ sale.offline_sales }}</td>
          <td>{{ sale.corporate_sales }}</td>
          <td>{{ sale.seller_sales }}</td>
        </tr>

        <!--          </router-link>-->
        </tbody>
      </table>
    </div>
    <modal name="chart-modal" height="auto">
      <div v-if="chartLoaded" class="p-4">
        <div id="chart">
          <apexchart type="area" height="350" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import {config} from "@/helpers";
import multiselect from "vue-multiselect";

export default {
  components: {multiselect},
  data() {
    return {
      myData : {},
      url         : "",
      inputFilters: {
        date: [],
        sort: {'total_sales' : 'ASC'}
      },
      sortBy: '',
      isFiltered  : false,
      filters     : {},
      suppliers: [],
      sales: [],
      chartLoaded: false,
      series: [{
        name: "Daily sale",
        data: []
      }],
    };
  },
  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/statistic";
    // this.getSuppliersList();
    this.getSaleStatistic();
  },
  methods: {
    async getSuppliersList() {
      await axios.get(this.url + "/products").then((response) => {
        this.suppliers = response.data.data.suppliers;
      });
    },
    getSaleStatistic(){

      console.log(this.myData);
      axios.get(this.url+"/products", { params: this.myData }).then((response) => {
        this.sales = response.data.data.sales;
      });
    },
    filter(){
      this.generateFilter();

      this.getSaleStatistic();
    },
    generateFilter(){
      this.isFiltered = true;
      let filters = {};

      if (this.inputFilters.date[0]) {
        filters.date = {};
        filters.date.start = this.inputFilters.date[0];
        filters.date.end = this.inputFilters.date[1];
      }

      if (this.inputFilters.sort) {
        filters.sort = this.inputFilters.sort;
      }

      if (this.inputFilters.supplier) {
        filters.supplier = this.inputFilters.supplier;
      }

      this.filters = filters;

      if (this.isFiltered) {
        let filters = this.filters;
        this.myData = {...this.myData,...filters };

      }
    },

    async showCompare(supplier) {
      this.inputFilters.supplier = supplier;
      this.chartOptions.title.text = supplier + " chart"
      this.generateFilter();

      await axios.get(this.url + "/report/detail", {params: this.myData}).then((response) => {

        this.chartOptions.xaxis.categories = response.data.data.dates;
        this.series[0].data = response.data.data.sale;
        this.chartLoaded = true;
      });

      this.$modal.show("chart-modal");
    },
    sortData(key){
      if(key == this.sortBy){
        this.sortBy = "";
        const direction = this.inputFilters.sort[key];
        this.inputFilters.sort = {
          [key]: direction === "DESC" ? "ASC" : "DESC"
        };

      }
      else{
        this.inputFilters.sort = {
          [key]: "DESC"
        };
      }
      this.sortBy = key;

      this.filter();
    },
  }
}
</script>

<style scoped>

</style>